/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */
/* 
`<dashboard-user-actions>` shows quick actions for user.

@demo bower_components/speedboat_ui/elements/demo/dashboard-user-info-demo.html
*/

// Import the PolymerElement base class and html helper
import { PolymerElement, html } from "@polymer/polymer";
import { mixinBehaviors } from "@polymer/polymer/lib/legacy/class.js";
import '@polymer/paper-ripple/paper-ripple.js';
import "../../chart.js/dist/Chart.bundle.js";
import "./dashboard-user-saving.js";
import '../../../behaviors/app-menu-access-behaviour.js';
import "../../speedboat_ui/elements/app-currency-selector.js"
import "./app-network-error.js";

// Define an element class
class dashboardPortfolio extends mixinBehaviors(
    [accessibilityBehaviours.commonFunctions, sbBehaviours.retailDashboardBehavior, corpBehaviours.appMenuBehaviour],
    PolymerElement
) {
    constructor() {
        super();
    }

    // Define the element's template
    static get template() {
        return html `
    <style  include="app-styles"> 
      .graph-bottom-nav iron-icon[icon="chevron-right"] {
        right: 0px;
        top: 4px;
      }

      .graph-bottom-nav iron-icon[icon="chevron-left"] {
        top: 4px;
        left: 0px;
      }

      canvas {
         margin: auto;
      }

      .savings-style, .investments-style, .loans-style, .cards-style, .total-assets-style, .total-liabilities-style {
        border-left: 5px solid;
        border-radius: 4px;
        box-shadow:  0px 1px 7px 0 var(--tabs-box-shadow-first);
        border-bottom: none;
        padding-top: 16px;
        padding-bottom: 16px;
      }

      .loans-style {
        border-color: var(--secondary-chart-color-40);
        margin-bottom: 4px;
      }

      .cards-style {
        border-color: var(--secondary-chart-color-100);
      }

      .investments-style {
        border-color: var(--primary-chart-color-100);

      }
      
      .total-assets-style{
        border-color: var(--primary-chart-color-100);
        margin-bottom: 4px;
      }

      .total-liabilities-style{
        border-color: var(--secondary-chart-color-100);
      }

      .savings-style {
        border-color: var(--primary-chart-color-80);
        margin-bottom: 4px;
      }

      .total-assets-style currency-formator, .total-assets-style paper-ripple {
        color: var(--primary-chart-color-100);

      }
      .min-height {
				min-height: 100px;
			}

      .total-liabilities-style currency-formator, .total-liabilities-style paper-ripple {
        color: var(--secondary-chart-color-100);
        border-bottom: none;
      }

      .portfolio-chart-wrapper {
        width: 150px;
        height: 150px;
        margin: 0 auto 20px;
      }

      .portfolio-chart-wrapper #myPortfolio {
        width: 100% !important;
        height: 100% !important;
      }
      
      .portfolio-container[desktop] {
        margin-top: -22px;
      }
      .margin{
      margin-top: 65px;
      }
      .chart-wrapper {
        height: calc(100% - 50px);
      }

      .chart-content {
        height: 206px;
        display: flex;
        align-content: flex-start;
      }

      .align-top-content {
        height: 206px;
      }
      .centralized-content{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width:fit-content;
      }
      .apply-button-style {
        border: 1px solid var(--brand-color);
        padding: 4px;
        border-radius: 18px;
        margin-top: 4px;
        min-width: 36px;
        text-align: center;
      }
      app-currency-selector {
        --currency-selector: {
          right:0 !important;
          left: initial !important;
      }
      }
      @media (max-width:767px) {
        .chart-header{
          max-width: calc(100% - 40px);
        }
      }
    </style>
  <!-- This is required to update the data for My profile(profile-summary component) -->
    <sb-app-localstorage-document session-only key="myProfileSummary" data="{{myProfileSummaryData}}">
		</sb-app-localstorage-document>
    <app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>
    <div class="justify-content-space-bwn mdl-grid padding-b-zero" >
      <div class="font-medium margin-zero mdl-grid primary-dark-text-m outlineOffset" tabindex="0" role="heading" level="2">
          <oe-i18n-msg msgid="l_myPortfolio"></oe-i18n-msg>
      </div>
      <app-currency-selector selected-country="{{selectedCountry}}" all-currencies="{{allCurrencies}}" hidden$="{{showNodataFetchMsg}}"></app-currency-selector>
    </div>
  <div hidden$={{showNoDetailsFlag}}>
    <div hidden$={{!showNodataFetchMsg}} class="centralized-content">
      <app-network-error  icon-name="cloud-off" background="light-background" description="l_try_after_sometime" title="l_could_not_fetch_data"></app-network-error>
    </div>
    </div>
    <template is="dom-if" if="{{showNoDetailsFlag}}" >
    
    <div class="min-height margin horizontal center-center layout">
    <supporting-msg  description="" icon-name="no_txn" background="light-background" title-msg="{{errMessage}}"></supporting-msg>
  </div>
      </template>
   

    <div hidden$={{showNodataFetchMsg}} id="portFolioContainer" class="chart-wrapper content-align-center">
      <div class="portfolio-container full-width" desktop$="{{desktop}}">
      
        <div hidden$="{{showLoader}}" class="content-align-center full-height">
          <!-- Chart wrapper template -->
          <div class="mdl-cell mdl-cell--6-col">
            <div id="myChart" class="portfolio-chart-wrapper"></div>
            <div class="content-align-center content-align-vertical-center font-size-s graph-bottom-nav height-element margin-b-zero mdl-cell mdl-cell--12-col mdl-grid padding-b-zero position-relative">
                <iron-icon id="left-icon" class="outlineOffset cursor-pointer position-absolute" icon="chevron-left" hidden$="{{!showLeftChevron}}" on-tap="_showPrevChart" tabindex="0"></iron-icon>
                <oe-i18n-msg class="chart-header text-align-center" msgid$="{{portfolioData.chartNavHeading}}"></oe-i18n-msg>
                <iron-icon id="right-icon" class="outlineOffset cursor-pointer full-height position-absolute right-icon-new" icon="chevron-right" on-tap="_showNextChart" hidden$="{{!showRightChevron}}" tabindex="0"></iron-icon>
            </div>
          </div>
          <!-- Chart wrapper template -->

          <div class$="chart-content margin-l-zero mdl-cell mdl-cell--6-col mdl-grid padding-l-zero {{chartWrapperClass}}">
            <div class$="margin-l-zero margin-r-zero margin-t-zero mdl-cell justify-content-space-bwn mdl-grid background-secondary border-round-4px full-width {{headerStyle}}" >
              <oe-i18n-msg class="font-size-m font-medium" msgid$="{{portfolioData.labelHeading}}"></oe-i18n-msg>
              <div  class="font-size-l font-medium">
                <span if={{checkNegative(balance)}} hidden$={{negativeSign}}>&#8722</span>
                <currency-formator id="netBalance" format-value="{{portfolioData.totalBalance}}" formatting-amount="[[phone]]"></currency-formator> 
              </div>
            </div>
            <template is='dom-repeat' items="{{chartData}}">
                <div id$="portfolioEachItem_{{item.labelText}}" class$="outlineOffset content-align-horizontal-end mdl-grid cursor-pointer border-b-1px position-relative full-width {{_getRowStyling(index, item)}}" data-args$="{{item}}" on-tap="_getRowDetails" tabindex="0">
                  <paper-ripple></paper-ripple>
                  <div class="full-width justify-content-space-bwn mdl-grid mdl-grid--no-spacing">
                    <oe-i18n-msg class="font-size-s" msgid$="{{item.labelText}}"></oe-i18n-msg>
                    <div class="font-size-s">
                      <currency-formator id="{{item.id}}" format-value="{{item.amount}}" formatting-amount="true"></currency-formator> 
                    </div>
                    <!-- <div id$="{{item.labelText}}"  class="full-width" hidden$="{{!_showCardsLastBilled(item.labelText)}}">
                      <div class="content-align-horizontal-end content-align-vertical-center" hidden$={{!cardsAvailable}}>
                          <iron-icon icon="info-outline" class="warning-color"></iron-icon>&nbsp;
                          <span class="secondary-dark-text-xs cursor-pointer">
                              <oe-i18n-msg msgid="l_TotalBilled"></oe-i18n-msg>&nbsp;
                              <currency-formator format-value={{lastBilledAmount}}></currency-formator>
                          </span>
                      </div> -->
                  </div>
                    <!-- Loans apply button -->
                  <template is="dom-if" if="{{!_isLoanMenuId()}}">
                    <div class="full-width" hidden$="{{!_checkLoans(item.labelText)}}">
                      <div class="full-width" hidden$={{loansAvailable}}>
                        <template is="dom-if" if={{!prospectLoansIndicatorFlag}}>
                            <div id="applyLoan_1" class="display-flex content-align-horizontal-end full-width">
                                <span on-tap="createLoanAccountDIB" class="outlineOffset font-size-xs apply-button-style position-relative" tabindex="0">
                                    <oe-i18n-msg msgid="b_apply"></oe-i18n-msg>
                                    <paper-ripple></paper-ripple>
                                </span>
                            </div>
                        </template>
                      </div>
                    </div>
                  </template>
                  <!-- Investments apply button -->
                  
                  <template is="dom-if" if="{{!_isInvestmentMenuId()}}">
                    <template is="dom-if" if={{_checkIsInvestment(item.labelText)}}>
                      <template is="dom-if" if={{!prospectInvestmentIndicatorFlag}}>
                        <div class="full-width" hidden$={{investmentsAvailable}}>
                          <div class="display-flex content-align-horizontal-end">
                            <span class="outlineOffset font-size-xs apply-button-style position-relative" on-tap="createInvestmentAccountDIB" tabindex="0">
                              <oe-i18n-msg msgid="b_apply"></oe-i18n-msg>
                              <paper-ripple></paper-ripple>
                            </span>
                          </div>  
                        </div>
                      </template> 
                    </template>   
                  </template>
                  
                  <!-- Cards apply button -->
                  <template is="dom-if" if="{{!_isCardsMenuId()}}">
                    <div class="full-width" hidden$="{{!_showCardsLastBilled(item.labelText)}}">
                      <div hidden$={{cardsAvailable}}>
                        <template is="dom-if" if={{!prospectCardsIndicatorFlag}}>
                            <div class="display-flex content-align-horizontal-end full-width">
                              <span class="outlineOffset font-size-xs apply-button-style position-relative" on-tap="createCardsAccountDIB" tabindex="0">
                                <oe-i18n-msg msgid="b_apply"></oe-i18n-msg>
                                <paper-ripple></paper-ripple>
                              </span>
                            </div>
                        </template>
                      </div>
                    </div>
                  </template>
                  <!-- Savings apply button -->
                  <template is="dom-if" if="{{!_isSavingsMenuId()}}">
                    <div class="full-width" hidden$="{{!_checkIsSavings(item.labelText)}}">
                      <div hidden$={{savingsAvailable}}>
                        <template is="dom-if" if={{!prospectSavingsIndicatorFlag}}>
                            <div class="display-flex content-align-horizontal-end full-width">
                              <span class="outlineOffset font-size-xs apply-button-style position-relative" on-tap="createSavingsAccountDIB" tabindex="0">
                                <oe-i18n-msg msgid="b_apply"></oe-i18n-msg>
                              </span>
                            </div>
                        </template>    
                      </div> 
                    </div> 
                  </template>
              </div>
            </template>
           
             
           	
          </div>
        </div>
      </div>
      <div class="full-width" hidden$="{{!showLoader}}">
        <paper-spinner id="portfolio_spinner" active></paper-spinner>
      </div>
    </div>
    `;
    }

    // Define public API properties
    static get properties() {
        return {
            myProfileSummaryData: {
                type: Object,
                notify: true
            },
            showTemplate: {
                type: Boolean,
                value: false
            },

            phone: {
                type: Boolean,
                value: false
            },
            savings: {
                type: Array,
                notify: true,
                observer: '_savingsListChanged'
            },
            cards: {
                type: Array,
                notify: true,
                observer: "_cardsListChanged",
            },
            loans: {
                type: Array,
                notify: true,
                observer: '_loansListChanged'
            },
            investments: {
                type: Array,
                notify: true,
                observer: '_investmentsListChanged'
            },
            savingsAmountList: {
                type: Array,
                notify: true,
                observer: "_checkPrimaryAccountCurrency"
            },
            activeSavingAccountStatus: {
                type: Array,
                value: ['A', '001', 'M', 'I', 'D', 'R', 'F', 'O']
            },
            /*List Active Status code for loan accounts*/
            activeLoanAccountStatus: {
                type: Array,
                value: ['A', '001', 'M', 'I', 'D', 'R', 'F', 'O']
            },
            /*List Active Status code for deposit accounts*/
            activeDepositAccountStatus: {
                type: Array,
                value: ['A', '001', 'M', 'I', 'D', 'R', 'F', 'O']
            },
      showNodataFetchMsg: {
        type: Boolean,
        value: false,
        notify: true
      },
      noDetailsFlag: {
        type: Boolean,
        notify: true,
        observer: '_showNoDetails'
      },
            /*List Active Status code for cards*/
            activeCardAccountStatus: {
                type: Array,
                value: ['A', '001', 'M', 'I', 'D', 'R', 'F', 'O']
            },
            savingsAccountSchemes: {
                type: Array,
                value: ['CAA', 'SBA']
            },
            cardsAccountSchemes: {
                type: Array,
                value: ["CCD"],
            },
            loansAccountSchemes: {
                type: Array,
                value: ['LAA']
            },
            investmentAccountSchemes: {
                type: Array,
                value: ['TDA', 'TUA']
            },
            chartData: {
                type: Array,
                value: []
            },
            chartLabels: {
                type: Array,
                value: function() {
                    return {
                        assets: 'l_totalAssetsLabel',
                        liabilities: 'l_totalLiabilitiesLabel',
                        savings: 'l_operativeAccounts',
                        cards: 'l_cards',
                        investments: 'l_investments',
                        assetsAndLiabilities: 'l_assetsAndLiabilities',
                        loans: 'l_loansLabel'
                    }
                }
            },
            portfolioData: {
                type: Object,
                value: {},
                notify: true
            },
            chartDataList: {
                type: Object,
                value: function() {
                    return {};
                },
                notify: true
            },
            showLeftChevron: {
                type: Boolean,
                value: false,
                notify: true
            },
            showRightChevron: {
                type: Boolean,
                value: true,
                notify: true
            },
            chartsAssetsList: {
                type: Array,
                value: []
            },
            chartsLiabilitiesList: {
                type: Array,
                value: []
            },
            chartBackgroundColor: {
                type: Array,
                value: ["#d54012", "#036adb"]
            },
            hoverColor: {
                type: Array
            },
            labelHeadingLists: {
                type: Object,
                value: {
                    totalBalances: 'l_totalBalances',
                    assets: 'l_assets',
                    liabilities: 'l_liabilities'
                }
            },
            labelHeading: {
                type: String,
                value: ''
            },
            showLoader: {
                type: Boolean,
                value: true
            },
            homeCurrency: {
                type: String,
                notify: true,
                observer: '_currencySelectorChanged'
            },
            selectedCountry: {
                type: String,
                notify: true,
                observer: '_currencySelectorChanged'
            },
            showAppCurrency: {
                type: Boolean,
                value: false,
                notify: true
            },
            allCurrencies: {
                type: Array,
                value: [],
                notify: true
            },
            loansAvailable: {
                type: Boolean,
                value: true,
                notify: true
            },
            prospectLoansIndicatorFlag: {
                type: Object,
                computed: 'computeProspectIndicator()'
            },
            prospectInvestmentIndicatorFlag: {
                type: Object,
                computed: 'computeProspectIndicator()'
            },
            prospectCardsIndicatorFlag: {
                type: Object,
                computed: 'computeProspectIndicator()'
            },
            prospectSavingsIndicatorFlag: {
                type: Object,
                computed: 'computeProspectIndicator()'
            },
            loanMenuId: {
                type: String,
                value: "ORLNS"
            },
            cardsMenuId: {
                type: String,
                notify: true,
                value: "ORCRD"
            },
            savingsMenuId: {
                type: String,
                notify: true,
                value: "ORACC"
            },
            investmentMenuId: {
                type: String,
                notify: true,
                value: "ORINV"
            },
            cardsAvailable: {
                type: Boolean,
                value: true,
                notify: true
            },
            investmentsAvailable: {
                type: Boolean,
                value: true,
                notify: true
            },
            savingsAvailable: {
                type: Boolean,
                value: true,
                notify: true
            },
            balance: {
                type: Number
            },
            negativeSign: {
                type: Boolean
            },
            accountResponse: {
                type: Array,
                notify: true,
                observer: '_accountfetching'
      },
      errMessage: {
        type: String,
        notify: true
            }

        };
    }
    static get observers() {
        return ['chartDataChange(chartDataList.*)'];
    }

    checkNegative(balanceVal) {

        if (balanceVal < 0) {
            this.negativeSign = false;
        } else {
            this.negativeSign = true;
        }
    }


    connectedCallback() {
        super.connectedCallback();
    }

    computeProspectIndicator() {
        return clientStorage.get(storageType.session, "prospectIndicator") == "Y";
    }

    _isLoanMenuId() {
        return this.validateElement(this.loanMenuId)
    }

    _isCardsMenuId() {
        return this.validateElement(this.cardsMenuId)
    }
    _isSavingsMenuId() {
        return this.validateElement(this.savingsMenuId)
    }

    _isInvestmentMenuId() {
        return this.validateElement(this.investmentMenuId)
    }

    _savingsListChanged() {
        var currencyValueList = [];
        var currencyValueMap = {};
        var savingsAmountList = [];
        this.savingsCurrency={};
        var pageTitle = document.getElementById('page-title-label');
        if (this.savings) {
            if (this.savings.length > 0) {
                for (var i = 0; i < this.savings.length; i++) {
                    if (this.savingsAccountSchemes.indexOf(this.savings[i].accountType.cmCode) > -1) {
                        var account = this.savings[i];
                        for (var j = 0; j < account.balances.length; j++) {
                            if (account.balances[j].type == "availableBalance") {
                                if (currencyValueMap[account.balances[j].amountDetails.currency] != undefined) {
                                    var temp = currencyValueMap[account.balances[j].amountDetails.currency];
                                    currencyValueList[temp] = Number(currencyValueList[temp]) + Number(account.balances[j].amountDetails.amount);
                                } else {
                                    currencyValueList.push(Number(account.balances[j].amountDetails.amount));
                                    currencyValueMap[account.balances[j].amountDetails.currency] = currencyValueList.length - 1;
                                }
                            }
                        }
                    }
                }

                for (var key in currencyValueMap) {
                    if (this.allCurrencies.indexOf(key) === -1) {
                        this.allCurrencies.push(key);
                    }
                    var index = currencyValueMap[key];
                    var val = currency.symbolize(key + ' ' + currencyValueList[index])
                    var amountValue = val.slice(2, val.length);
                    amountValue = amountValue[amountValue.length - 3] == "." ? amountValue.slice(0, amountValue.length - 3) : amountValue;
                    var showTooltip = amountValue.length >= 4 ? true : false;
                    savingsAmountList.push({ "amount": val, currency: key, "showTooltip": showTooltip });
                }
                this.savingsCurrency=currencyValueMap;
                this.savingsAmountList = savingsAmountList
                this.savingsAmountList.name = this.chartLabels.savings;
                this.chartsAssetsList.push(this.savingsAmountList);
                this.set('chartDataList.savingsChartData', currencyValueList[0]); // This has to checked

            } else if (pageTitle.appData.savingsSuggestionsCallDone === undefined) {
                var self = this;
                this.savingsAvailable = false;
                pageTitle.appData.savingsSuggestionsCallDone = true;
                if (this.prospectSavingsIndicatorFlag) {

                    this.set('savingsSuggestions', {});
                    pageTitle.appData.savingsSuggestions = this.savingsSuggestions;
                    return;
                }
                var ajaxCall = document.createElement('oe-ajax');
                ajaxCall.contentType = "application/json";
                ajaxCall.handleAs = "json";
                ajaxCall.url = "/api/accountSuggestions/savings";
                ajaxCall.method = 'get';
                ajaxCall.addEventListener('response', function(event) {
                    if (event.detail.response != null) {
                        var suggestions = event.detail.response.accountSuggestion;
                        self.set('savingsSuggestions', suggestions);
                        pageTitle.appData.savingsSuggestions = self.savingsSuggestions;
                    }
                });
                ajaxCall.addEventListener("error", function(e) {
                    self.set('savingsSuggestions', {});
                });
                oeAjaxEventListner(ajaxCall);
                ajaxCall.generateRequest();
            } else {
                this.savingsAvailable = false;
                if (pageTitle.appData.savingsSuggestions) {
                    this.set('savingsSuggestions', pageTitle.appData.savingsSuggestions);
                }
            }

            if (this.savings.length === 0) {
                this.savingsAmountList = [{ "amount": 0, "showTooltip": false }];
                this.savingsAmountList.name = this.chartLabels.savings;
                this.chartsAssetsList.push(this.savingsAmountList);
                this.set('chartDataList.savingsChartData', 0); // This has to checked
            }
        }
    }
  _showNoDetails() {
    this.showNodataFetchMsg = this.noDetailsFlag;
    this.showLoader = false;
    this.showNoDetailsFlag = this.noDetailsFlag;

  }
  _checkPrimaryAccountCurrency() {
    this.otherCurrencies = [];
    this.primaryBalance = [];
    this.otherCurrenciesFlag = false;
    let primaryCurrency = _.isEmpty(this.primaryAccountObj) ? "" : currency.symbolize(this.primaryAccountObj.accountCurrency.cmCode);

        if (this.savingsAmountList) {
            for (let amount of this.savingsAmountList) {
                if (amount.amount === 0 || amount.amount.split(" ")[0] == primaryCurrency) {
                    this.primaryBalance.push(amount);
                } else {
                    this.otherCurrenciesFlag = true;
                    this.otherCurrencies.push(amount);
                }
            }
            if (this.primaryBalance.length == 0) {
                this.primaryBalance.push(this.otherCurrencies[0]);
                this.otherCurrencies.splice(0, 1);
                this.otherCurrenciesFlag = this.otherCurrencies.length ? true : false;
            }
        }
    }

    _cardsListChanged() {
        var currencyValueList = [];
        var currencyValueMap = {};
        var cardsAmountList = [];
        var currencyValueBilledAmountList = [];
        var currencyValueBilledAmountMap = {};
        var pageTitle = document.getElementById("page-title-label");
        if (this.cards) {
            if (this.cards.length > 0) {
                for (var i = 0; i < this.cards.length; i++) {
                    if (
                        this.cardsAccountSchemes.indexOf(this.cards[i].accountType.cmCode) >
                        -1
                    ) {
                        var account = this.cards[i];
                        for (var j = 0; j < account.balances.length; j++) {
                            if (account.balances[j].type == "availableCreditLimit") {
                                if (
                                    currencyValueMap[
                                        account.balances[j].amountDetails.currency
                                    ] != undefined
                                ) {
                                    var temp =
                                        currencyValueMap[
                                            account.balances[j].amountDetails.currency
                                        ];
                                    currencyValueList[temp] =
                                        Number(currencyValueList[temp]) +
                                        Number(account.balances[j].amountDetails.amount);
                                } else {
                                    currencyValueList.push(
                                        Number(account.balances[j].amountDetails.amount)
                                    );
                                    currencyValueMap[account.balances[j].amountDetails.currency] =
                                        currencyValueList.length - 1;
                                }
                            }
                            if (account.balances[j].type == "lastBilledAmount") {
                                if (
                                    currencyValueBilledAmountMap[
                                        account.balances[j].amountDetails.currency
                                    ] != undefined
                                ) {
                                    var temp1 =
                                        currencyValueBilledAmountMap[
                                            account.balances[j].amountDetails.currency
                                        ];
                                    currencyValueBilledAmountList[temp1] =
                                        Number(currencyValueBilledAmountList[temp1]) +
                                        Number(account.balances[j].amountDetails.amount);
                                } else {
                                    currencyValueBilledAmountList.push(
                                        Number(account.balances[j].amountDetails.amount)
                                    );
                                    currencyValueBilledAmountMap[
                                        account.balances[j].amountDetails.currency
                                    ] = currencyValueBilledAmountList.length - 1;
                                }
                            }
                        }
                    }
                }

                for (let key in currencyValueMap) {
                    let index = currencyValueMap[key];
                    let val = currency.symbolize(key + " " + currencyValueList[index]);
                    var amountValue = val.slice(2, val.length);
                    amountValue =
                        amountValue[amountValue.length - 3] == "." ?
                        amountValue.slice(0, amountValue.length - 3) :
                        amountValue;
                    var showTooltip = amountValue.length >= 4 ? true : false;
                    cardsAmountList.push({ amount: val, currency: key, showTooltip: showTooltip });
                }

                for (let key in currencyValueBilledAmountMap) {
                    let index = currencyValueBilledAmountMap[key];
                    let val = currency.symbolize(
                        key + " " + currencyValueBilledAmountList[index]
                    );
                    if (this.lastBilledAmount)
                        this.lastBilledAmount = this.lastBilledAmount + ", " + val;
                    else this.lastBilledAmount = val;
                }

                this.cardsAmountList = cardsAmountList;
                this.cardsAmountList.name = this.chartLabels.cards;
                this.chartsLiabilitiesList.push(this.cardsAmountList);
                this.set('chartDataList.cardChartData', currencyValueList[0]);
            } else if (pageTitle.appData.cardsSuggestionsCallDone === undefined) {
                var self = this;
                this.cardsAvailable = false;
                pageTitle.appData.cardsSuggestionsCallDone = true;
                if (this.prospectCardsIndicatorFlag) {
                    this.set('cardsSuggestions', {});
                    pageTitle.appData.cardsSuggestions = this.cardsSuggestions;
                    return;
                }
                var ajaxCall = document.createElement('oe-ajax');
                ajaxCall.contentType = "application/json";
                ajaxCall.handleAs = "json";
                ajaxCall.url = "/api/accountSuggestions/cards";
                ajaxCall.method = 'get';
                ajaxCall.addEventListener('response', function(event) {
                    if (event.detail.response != null) {
                        var suggestions = event.detail.response.accountSuggestion;
                        suggestions.formattedAmount = currency.symbolize(suggestions.currency + ' ' + suggestions.amount);
                        self.set('cardsSuggestions', suggestions);
                        pageTitle.appData.cardsSuggestions = self.cardsSuggestions;
                    }
                });
                ajaxCall.addEventListener("error", function(e) {
                    self.set('cardsSuggestions', {});
                });
                oeAjaxEventListner(ajaxCall);
                ajaxCall.generateRequest();
            } else {
                this.cardsAvailable = false;
                if (pageTitle.appData.cardsSuggestions) {
                    this.set('cardsSuggestions', pageTitle.appData.cardsSuggestions);
                }
            }

            if (this.cards.length === 0) {
                this.cardsAmountList = [{ "amount": 0, "showTooltip": false }];
                this.cardsAmountList.name = this.chartLabels.cards;
                this.chartsLiabilitiesList.push(this.cardsAmountList);
                this.set('chartDataList.cardChartData', 0);
            }
        }
    }

    _loansListChanged() {
        var currencyValueList = [];
        var currencyValueMap = {};
        var loansAmountList = [];
        var pageTitle = document.getElementById('page-title-label');
        if (this.loans) {
            if (this.loans.length > 0) {
                for (var i = 0; i < this.loans.length; i++) {
                    if (this.loansAccountSchemes.indexOf(this.loans[i].accountType.cmCode) > -1) {
                        var account = this.loans[i];
                        for (var j = 0; j < account.balances.length; j++) {
                            if (account.balances[j].type == "dueAmount") {
                                if (currencyValueMap[account.balances[j].amountDetails.currency] != undefined) {
                                    var temp = currencyValueMap[account.balances[j].amountDetails.currency];
                                    currencyValueList[temp] = Number(currencyValueList[temp]) + Number(account.balances[j].amountDetails.amount);
                                } else {
                                    currencyValueList.push(Number(account.balances[j].amountDetails.amount));
                                    currencyValueMap[account.balances[j].amountDetails.currency] = currencyValueList.length - 1;
                                }
                            }
                        }
                    }
                }


                for (var key in currencyValueMap) {
					if (this.allCurrencies.indexOf(key) === -1) {
                        this.allCurrencies.push(key);
                    }
                    var index = currencyValueMap[key];
                    var val = currency.symbolize(key + ' ' + Math.abs(currencyValueList[index]));
                    var amountValue = val.slice(2, val.length);
                    amountValue = amountValue[amountValue.length - 3] == "." ? amountValue.slice(0, amountValue.length - 3) : amountValue;
                    var showTooltip = amountValue.length >= 4 ? true : false;
                    loansAmountList.push({ "amount": val, currency: key, "showTooltip": showTooltip });
                }
                this.loansAmountList = loansAmountList;
                this.loansAmountList.name = this.chartLabels.loans;
                this.chartsLiabilitiesList.push(this.loansAmountList);
                this.set('chartDataList.loansChartData', Math.abs(currencyValueList[0]));
            } else if (pageTitle.appData.loansSuggestionsCallDone === undefined) {
                var self = this;
                this.loansAvailable = false;
                pageTitle.appData.loansSuggestionsCallDone = true;
                if (this.prospectLoansIndicatorFlag) {
                    this.set('loansSuggestions', {});
                    pageTitle.appData.loansSuggestions = this.loansSuggestions;
                    return;
                }
                var ajaxCall = document.createElement('oe-ajax');
                ajaxCall.contentType = "application/json";
                ajaxCall.handleAs = "json";
                ajaxCall.url = "/api/accountSuggestions/loans";
                ajaxCall.method = 'get';
                ajaxCall.addEventListener('response', function(event) {
                    if (event.detail.response != null) {
                        var suggestions = event.detail.response.accountSuggestion;
                        suggestions.formattedAmount = currency.symbolize(suggestions.currency + ' ' + suggestions.amount);
                        self.set('loansSuggestions', suggestions);
                        pageTitle.appData.loansSuggestions = self.loansSuggestions;
                    }
                });
                ajaxCall.addEventListener("error", function(e) {
                    self.set('loansSuggestions', {});
                });
                oeAjaxEventListner(ajaxCall);
                ajaxCall.generateRequest();
            } else {
                this.loansAvailable = false;
                if (pageTitle.appData.loansSuggestions) {
                    this.set('loansSuggestions', pageTitle.appData.loansSuggestions);
                }
            }


            if (this.loans.length === 0) {
                this.loansAmountList = [{ "amount": 0, "showTooltip": false }];
                this.loansAmountList.name = this.chartLabels.loans;
                this.chartsLiabilitiesList.push(this.loansAmountList);
                this.set('chartDataList.loansChartData', 0);
            }
        }
    }


    _investmentsListChanged() {
        var currencyValueList = [];
        var currencyValueMap = {};
        var investmentsAmountList = [];
        this.investmentCurrency={};
        var pageTitle = document.getElementById('page-title-label');

        if (this.investments) {
            if (this.investments.length > 0) {
                if (this.bonds) {
                    for (let i = 0; i < this.bonds.length; i++) {
                        if (currencyValueMap[this.bonds[i].bondCurrency] != undefined) {
                            let temp = currencyValueMap[this.bonds[i].bondCurrency];
                            currencyValueList[temp] = Number(currencyValueList[temp]) + Number(this.bonds[i].marketValue.amount);
                        } else {
                            currencyValueList.push(Number(this.bonds[i].marketValue.amount));
                            currencyValueMap[this.bonds[i].bondCurrency] = currencyValueList.length - 1;
                        }
                    }
                }
                for (var i = 0; i < this.investments.length; i++) {
                    if (this.investmentAccountSchemes.indexOf(this.investments[i].accountType.cmCode) > -1) {
                        var account = this.investments[i];
                        for (var j = 0; j < account.balances.length; j++) {
                            if (account.balances[j].type == "clearBalance") {
                                if (currencyValueMap[account.balances[j].amountDetails.currency] != undefined) {
                                    var temp = currencyValueMap[account.balances[j].amountDetails.currency];
                                    currencyValueList[temp] = Number(currencyValueList[temp]) + Number(account.balances[j].amountDetails.amount);
                                } else {
                                    currencyValueList.push(Number(account.balances[j].amountDetails.amount));
                                    currencyValueMap[account.balances[j].amountDetails.currency] = currencyValueList.length - 1;
                                }
                            }
                        }
                    }
                }

                for (var key in currencyValueMap) {
                    if (this.allCurrencies.indexOf(key) === -1) {
                        this.allCurrencies.push(key);
                    }
                    var index = currencyValueMap[key];
                    var val = currency.symbolize(key + ' ' + Number(currencyValueList[index]));
                    var amountValue = val.slice(2, val.length);
                    amountValue = amountValue[amountValue.length - 3] == "." ? amountValue.slice(0, amountValue.length - 3) : amountValue;
                    var showTooltip = amountValue.length >= 4 ? true : false;
                    investmentsAmountList.push({ "amount": val, currency: key, "showTooltip": showTooltip });
                }
                this.investmentCurrency = currencyValueMap;
                this.investmentsAmountList = investmentsAmountList;
                this.investmentsAmountList.name = this.chartLabels.investments;
                this.chartsAssetsList.push(this.investmentsAmountList);
                this.set("chartDataList.investmentsChartData", currencyValueList[index]);
            } else if (pageTitle.appData.investmentsSuggestionsCallDone === undefined) {
                var self = this;
                this.investmentsAvailable = false;
                pageTitle.appData.investmentsSuggestionsCallDone = true;
                if (this.prospectInvestmentIndicatorFlag) {
                    this.set('investmentsSuggestions', {});
                    pageTitle.appData.investmentsSuggestions = this.investmentsSuggestions;
                    return;
                }

                var ajaxCall = document.createElement('oe-ajax');
                ajaxCall.contentType = "application/json";
                ajaxCall.handleAs = "json";
                ajaxCall.url = "/api/accountSuggestions/investments";
                ajaxCall.method = 'get';
                ajaxCall.addEventListener('response', function(event) {
                    if (event.detail.response != null) {
                        var suggestions = event.detail.response.accountSuggestion;
                        self.set('investmentsSuggestions', suggestions);
                        pageTitle.appData.investmentsSuggestions = self.investmentsSuggestions;
                    }
                });
                ajaxCall.addEventListener("error", function(e) {
                    self.set('investmentsSuggestions', {});
                });
                oeAjaxEventListner(ajaxCall);
                ajaxCall.generateRequest();
            } else {
                this.investmentsAvailable = false;
                if (pageTitle.appData.investmentsSuggestions) {
                    this.set('investmentsSuggestions', pageTitle.appData.investmentsSuggestions);
                }
            }
            if (this.investments.length === 0) {
                this.investmentsAmountList = [{ "amount": 0, "showTooltip": false }];
                this.investmentsAmountList.name = this.chartLabels.investments;
                this.chartsAssetsList.push(this.investmentsAmountList);
                this.set("chartDataList.investmentsChartData", 0);
            }
        }
    }

    ready() {
        super.ready();
        this.showTemplate = true;
        this.set("portfolioData.chartNavHeading", this.chartLabels.assetsAndLiabilities);
        if (window.webpackEnabled) {
            this.eleSelect = document.querySelector("sb-app-route");
        } else {
            this.eleSelect = document.querySelector("oe-app-route");
        }
        this._getAjaxBondServiceCall('/investmentsaccounts/bonds/holdings');
        // this._getAjaxServiceCall('accounts');
        this._getAjaxHomeCurrency();
        this.chartsAssetsList = [];
        this.chartsLiabilitiesList = [];
        this.showLoader=true;
    }
    _accountfetching() {
        var self = this;
        var list = self.accountResponse;


        var accOPR = [];
        var accLON = [];
        var accDEP = [];
        var accCCD = [];

        for (var i = 0; i < list.length; i++) {
            if (list[i].parentAccountType.cmCode === "OPR") accOPR.push(list[i]);
            else if (list[i].parentAccountType.cmCode === "LON") accLON.push(list[i]);
            else if (list[i].parentAccountType.cmCode === "DEP") accDEP.push(list[i]);
            else if (list[i].parentAccountType.cmCode === "CCD") accCCD.push(list[i]);
        }
        /* Saving Account */


        self.savingsWithAllAccounts = accOPR;
        clientStorage.set(storageType.session, 'operativeAccountList', self.savingsWithAllAccounts); // self.appData.savings = accOPR;

        self._createSavingsList(self.savingsWithAllAccounts);

        self.loansWithAllAccounts = accLON; // self.appData.loans = accLON;

        self._createLoansList(self.loansWithAllAccounts);

        self.investmentsWithAllAccounts = accDEP; // self.appData.investments = accDEP;

        self._createInvestmentsList(self.investmentsWithAllAccounts);

        self.cardsWithAllAccounts = accCCD; // self.appData.cards = accCCD;

        self._createCardsList(self.cardsWithAllAccounts); // this._getAjaxServiceCall('preferences');
        // if homecurrency has 0 accounts
        let homeAccounts = _.filter(self.accountResponse,{ "accountCurrency" : { "cmCode" : this.homeCurrency }});
        if(homeAccounts.length === 0){
            let homeIndex = this.allCurrencies.indexOf(this.homeCurrency);
            this.allCurrencies.splice(homeIndex,1);
            if(this.allCurrencies.length){
                this.selectedCountry = this.allCurrencies[0];
            }
        }
    }

    _getAjaxHomeCurrency() {
        this.allCurrencies = []
        var self = this;
        self.userId = clientStorage.get(storageType.session, 'userId');
        var getPayables = document.createElement("oe-ajax");
        getPayables.contentType = "application/json";
        getPayables.handleAs = "json";
        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = "/api/propertyreferences?filter[where][propertyName]=HOME_CUR_CODE";
        ajaxCall.method = 'get';
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
        ajaxCall.addEventListener('response', function(event) {
            clientStorage.set(storageType.session, 'homeCurrency', event.detail.response[0].propertyValue);
            self.homeCurrency = event.detail.response[0].propertyValue;
            self.selectedCurrency = event.detail.response[0].propertyValue;
            self.selectedCountry = event.detail.response[0].propertyValue;
            // If there is delay in response, then the selectedCurrency was have having undefined value, and hence 
            // in "getTotalValues()" function "eachItem.amount !== 0 && eachItem.currency === this.selectedCurrency" was failing
            self.allCurrencies.push(self.homeCurrency)
            let canvas = self.$.myChart.querySelector('#myPortfolio');
            if (!canvas) {
                self.chartDataChange();
            }
        })
    }

    /* Generic function for doing ajax call */
    _getAjaxServiceCall(modelAPI) {
        this.userId = clientStorage.get(storageType.session, "userId");
        var ajaxCall = document.createElement('oe-ajax');
        var self = this;
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = "/api/CBUsers/" + self.userId + "/" + modelAPI;
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function(event) {
            self._filterResponse(modelAPI, event.detail.response, self);
        });
        ajaxCall.addEventListener("error", function(e) {
            // self.serviceError(e, modelAPI);
            self.showLoader = false;
            self.showNodataFetchMsg = true;
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
    }

    /*Get list for bonds holdings*/
    _getAjaxBondServiceCall(urlForId) {
        var ajaxCall = document.createElement('oe-ajax');
        var self = this;
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = "/api/CBUsers/" + clientStorage.get(storageType.session, "userId") + urlForId;
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function(event) {
            self.bonds = event.detail.response;
        });
        ajaxCall.addEventListener("error", function(e) {
            // self.serviceError(e, urlForId);
            // self.showLoader = false;
        });
        ajaxCall.generateRequest();
    }

    _filterResponse(modelAPI, list, self) {

        switch (modelAPI) {
            case "accounts":

                var accOPR = [];
                var accLON = [];
                var accDEP = [];
                var accCCD = [];

                for (var i = 0; i < list.length; i++) {
                    if (list[i].parentAccountType.cmCode === "OPR") accOPR.push(list[i]);
                    else if (list[i].parentAccountType.cmCode === "LON") accLON.push(list[i]);
                    else if (list[i].parentAccountType.cmCode === "DEP") accDEP.push(list[i]);
                    else if (list[i].parentAccountType.cmCode === "CCD") accCCD.push(list[i]);
                }
                /* Saving Account */
                self.savingsWithAllAccounts = accOPR;
                clientStorage.set(storageType.session, 'operativeAccountList', self.savingsWithAllAccounts);
                // self.appData.savings = accOPR;
                self._createSavingsList(self.savingsWithAllAccounts);

                self.loansWithAllAccounts = accLON;
                // self.appData.loans = accLON;
                self._createLoansList(self.loansWithAllAccounts);

                self.investmentsWithAllAccounts = accDEP;
                // self.appData.investments = accDEP;
                self._createInvestmentsList(self.investmentsWithAllAccounts);

                self.cardsWithAllAccounts = accCCD;
                // self.appData.cards = accCCD;
                self._createCardsList(self.cardsWithAllAccounts);

                // this._getAjaxServiceCall('preferences');

                break;
        }
    }

    /* Function for creatinf savings list without closed account */
    _createSavingsList(list) {
        var self = this;
        var tempList = [];

        for (var i = 0; i < list.length; i++) {
            if (list[i].accountStatus != undefined && list[i].accountStatus.cmCode != undefined && self.activeSavingAccountStatus.indexOf(list[i].accountStatus.cmCode) > -1) {
                tempList.push(list[i]);
            }
        }

        this.savings = tempList;
    }

    /* Function for creatinf loans list without closed account */
    _createLoansList(list) {
        var self = this;
        var tempList = [];

        for (var i = 0; i < list.length; i++) {
            if (list[i].accountStatus != undefined && list[i].accountStatus.cmCode != undefined && self.activeLoanAccountStatus.indexOf(list[i].accountStatus.cmCode) > -1) {
                tempList.push(list[i]);
            }
        }

        this.loans = tempList;
    }

    /* Function for creatinf deposit list without closed account */
    _createInvestmentsList(list) {
            var self = this;
            var tempList = [];

            for (var i = 0; i < list.length; i++) {
                if (list[i].accountStatus != undefined && list[i].accountStatus.cmCode != undefined && self.activeDepositAccountStatus.indexOf(list[i].accountStatus.cmCode) > -1) {
                    tempList.push(list[i]);
                }
            }

            this.investments = tempList;
        }
        /* Function for creatinf cards list without closed account */
    _createCardsList(list) {
        var self = this;
        var tempList = [];

        for (var i = 0; i < list.length; i++) {
            if (list[i].accountStatus != undefined && list[i].accountStatus.cmCode != undefined && self.activeCardAccountStatus.indexOf(list[i].accountStatus.cmCode) > -1) {
                tempList.push(list[i]);
            }
        }

        this.cards = tempList;
    }

    chartDataChange() {
        // This is required to update the data for My profile(profile-summary component) 
        if (this.savings && this.cards && this.investments && this.loans) {
            this.myProfileSummaryData = {};
            var summaryData = {
                accounts: this.savings.length,
                deposits: this.investments.length,
                loans: this.loans.length,
                creditcards: this.cards.length,
            };
            this.myProfileSummaryData = summaryData;
            var accountList = [];
            accountList = accountList.concat(this.savings);
            accountList = accountList.concat(this.investments);
            accountList = accountList.concat(this.loans);
            accountList = accountList.concat(this.cards);
            clientStorage.set(storageType.session, 'accountList', accountList);
        }
        if (this.chartDataList.savingsChartData !== undefined && this.chartDataList.cardChartData !== undefined &&
            this.chartDataList.loansChartData !== undefined && this.chartDataList.investmentsChartData !== undefined &&
            this.selectedCurrency !== undefined) {
            this.drawGraph();
        }
    }

    _showCardsLastBilled(label) {
        return label === this.chartLabels.cards;
    }

    _checkLoans(label) {
        return label === this.chartLabels.loans;
    }

    _checkIsInvestment(label) {
        return label === this.chartLabels.investments;
    }

    _checkIsSavings(label) {
        return label === this.chartLabels.savings;
    }

    _getRowStyling(index, item) {
        //  let className = item.labelText === this.labelText.totalAssets ? 'total-assets-style' : '';
        //  className = 
        if (item.labelText === this.chartLabels.assets) {
            this.headerStyle = '';
            return 'total-assets-style cursor-pointer';
        } else if (item.labelText === this.chartLabels.liabilities) {
            return 'total-liabilities-style cursor-pointer';
        } else if (item.labelText === this.chartLabels.savings) {
            this.headerStyle = 'mdl-cell full-width margin-l-zero margin-r-zero margin-t-zero';
            return 'savings-style';
        } else if (item.labelText === this.chartLabels.investments) {
            return 'investments-style';
        } else if (item.labelText === this.chartLabels.cards) {
            this.headerStyle = 'mdl-cell full-width margin-l-zero margin-r-zero margin-t-zero';
            return 'cards-style';
        } else if (item.labelText === this.chartLabels.loans) {
            return 'loans-style';
        }
    }

    getTotalValues() {
        this.chartWrapperClass = '';
        this.set("portfolioData.chartNavHeading", this.chartLabels.assetsAndLiabilities);
        this.showLeftChevron = false;
        this.showRightChevron = true;
        this.chartBackgroundColor = ["#036adb", "#d54012"];
        this.hoverColor = ["#036adb"]
        this.set("portfolioData.labelHeading", this.labelHeadingLists.totalBalances);
        let totalAssets = 0,
            totalLiabilities = 0,
            chartLabelObject = [],
            assetsAndLiabilities = [];
        this.chartsAssetsList.forEach(item => {
            item.forEach(eachItem => {
                if (eachItem.amount !== 0 && eachItem.currency === this.selectedCurrency) {
                  //earlier was parseInt. changing to parseFloat to preserve decimal value from the api response for defect 419682
                  totalAssets = totalAssets + parseFloat(eachItem.amount.split(' ')[1].replace(/,/g, ''));
                        } else {
                    totalAssets = totalAssets;
                }
            })
        });
        const tempAssetsObj = { 'labelText': this.chartLabels.assets, 'amount': currency.symbolize(this.selectedCurrency + ' ' + totalAssets), 'eachChartData': totalAssets }
        chartLabelObject.push(tempAssetsObj);
        assetsAndLiabilities.push(totalAssets);
        this.chartsLiabilitiesList.forEach(item => {
            item.forEach(eachItem => {
                if (eachItem.amount !== 0 && eachItem.currency === this.selectedCurrency) {
                  //earlier was parseInt. changing to parseFloat to preserve decimal value from the api response for defect 419682
                  totalLiabilities = totalLiabilities + parseFloat(eachItem.amount.split(' ')[1].replace(/,/g, ''));
                } else {
                    totalLiabilities = totalLiabilities;
                }
            })
        });
        const tempLiabilitiesObj = { 'labelText': this.chartLabels.liabilities, 'amount': currency.symbolize(this.selectedCurrency + ' ' + totalLiabilities), 'eachChartData': totalLiabilities }
        chartLabelObject.push(tempLiabilitiesObj);
        assetsAndLiabilities.push(totalLiabilities);
        const totalBalance = totalAssets - totalLiabilities;
        const labels = [this.chartLabels.assets, this.chartLabels.liabilities]
        this.portfolioData.assetsAndLiabilities = assetsAndLiabilities;
        this.portfolioData.chartLabelObject = chartLabelObject;
        this.portfolioData.labels = labels;
        this.set("balance", totalBalance)
        this.set("portfolioData.totalBalance", currency.symbolize(this.selectedCurrency + ' ' + totalBalance));
        this.checkNegative(totalBalance);
        if (this.myChart) {
            this.myChart.destroy();
            this.drawGraph();
        }
    }

    getIndividualChartValues(chartListValues) {
        let individualChartValues = [],
            currencySymbol = this.selectedCurrency,
            chartLabelObject = [];
        chartListValues.forEach(item => {
            let amount = 0;
            item.forEach(eachItem => {
                if (eachItem.amount === 0) {
                    amount = 0;
                } else if (eachItem.currency === this.selectedCurrency) {
                  //earlier was parseInt. changing to parseFloat to preserve decimal value from the api response for defect 419682
                  amount = parseFloat(eachItem.amount.split(' ')[1].replace(/,/g, ''));
                }
            })
            const eachLabelObj = {};
            individualChartValues.push(amount);
            eachLabelObj.labelText = item.name;
            eachLabelObj.amount = currency.symbolize(currencySymbol + ' ' + amount)
            chartLabelObject.push(eachLabelObj);
        });
        let totalBalance = 0;
        individualChartValues.forEach(item => {
            totalBalance = totalBalance + item;
        });
        this.portfolioData.assetsAndLiabilities = null;
        this.portfolioData.individualChartValues = individualChartValues;
        this.portfolioData.chartLabelObject = chartLabelObject;
        this.set("portfolioData.totalBalance", currency.symbolize(currencySymbol + ' ' + totalBalance));

        this.myChart.destroy();
        this.drawGraph();
    }

    _setAssetsValues() {
        this.negativeSign = true;
        this.chartWrapperClass = 'align-top-content';
        this.set('portfolioData.chartNavHeading', this.labelHeadingLists.assets);
        this.set("portfolioData.labelHeading", this.labelHeadingLists.assets);
        this.chartBackgroundColor = ['#31adf5', "#036adb"];
        this.hoverColor = ['#31adf5']
        this.portfolioData.labels = [this.chartLabels.savings, this.chartLabels.investments];
        this.getIndividualChartValues(this.chartsAssetsList);
        this.showLeftChevron = true;
        this.showRightChevron = true;
    }

    _setLiabilitiesValues() {
        this.negativeSign = true;
        this.chartWrapperClass = 'align-top-content';
        this.set("portfolioData.chartNavHeading", this.labelHeadingLists.liabilities)
        this.set("portfolioData.labelHeading", this.labelHeadingLists.liabilities);
        this.chartBackgroundColor = ["#d99782", "#d54012"];
        this.hoverColor = ["#d99782"]
        this.portfolioData.labels = [this.chartLabels.loans, this.chartLabels.cards];
        this.getIndividualChartValues(this.chartsLiabilitiesList);
        this.showRightChevron = false;
        this.showLeftChevron = true;
    }

    _getRowDetails(e) {
        const labelText = e.model ? e.model.item.labelText : e;

        if (labelText === this.chartLabels.investments) {
            //this._navigateToInvestment();
        } else if (labelText === this.chartLabels.savings) {
            if (this.savingsAvailable === false) {
                return;
            } else {
                this._navigateToSaving();
            }
        } else if (labelText === this.chartLabels.loans) {
            // this._navigateToLoan();
        } else if (labelText === this.chartLabels.cards) {
            this._navigateToCard();
        }


        if (labelText === this.labelHeadingLists.assets || labelText === this.chartLabels.assets) {
            this._setAssetsValues();
        } else if (labelText === this.labelHeadingLists.liabilities || labelText === this.chartLabels.liabilities) {
            this._setLiabilitiesValues();
        } else if (e.model) {
            if (e.model.item.labelText === this.chartLabels.savings) {
                if (this.savingsAvailable === false) {
                    return;
                } else {
                    this._navigateToSaving();
                }
            } else if (e.model.item.labelText === this.chartLabels.cards) {
                this._navigateToCard();
            } else if (e.model.item.labelText === this.chartLabels.investments) {
                this._navigateToInvestment();
            } else if (e.model.item.labelText === this.chartLabels.loans) {
                this._navigateToLoan();
            }
        }
    }

    _navigateToInvestment() {
        if (this.validateElement(this.investmentMenuId)) {
      this.fire("oe-show-message", getLabel('l_PermissionErrorMessage'));
            return;
        }

        var self = this;
        var detailsURL = "/depositAcctLanding";

        var detailsNavigationData = {
            'investmentAccountList': this.investments,
            'investmentsAmountList': this.investmentsAmountList
        };

        this.getDataForIds(this.investments, "/api/CBUsers/" + clientStorage.get(storageType.session, "userId") + "/depositaccounts", function(list) {
            detailsNavigationData = {
                'investmentAccountList': list,
                'investmentsAmountList': self.investmentsAmountList
            };
            window.oe_navigate_to(detailsURL, detailsNavigationData);
        });
    }

    _navigateToLoan() {
        if (this.validateElement(this.loanMenuId)) {
      this.fire("oe-show-message", getLabel('l_PermissionErrorMessage'));
            return;
        }
        var detailsURL = "/loanAcctLanding";
        var detailsNavigationData = { loanAccountList: this.loansWithAllAccounts };
        this.getDataForIds(this.loansWithAllAccounts, "/api/CBUsers/" + clientStorage.get(storageType.session, "userId") + "/loanaccounts", function(list) {
            detailsNavigationData = {
                loanAccountList: list
            };
            window.oe_navigate_to(detailsURL, detailsNavigationData);
        });
    }


    _navigateToSaving() {
        if (this.validateElement(this.savingsMenuId)) {
      this.fire("oe-show-message", getLabel('l_PermissionErrorMessage'));
            return;
        }
        var detailsURL = "/oprAccounts";
        var detailsNavigationData = { "oprAccountList" : this.savings };
        this.getDataForIds(this.savings, "/api/CBUsers/" + clientStorage.get(storageType.session, "userId") + "/operativeaccounts", function(list){
            detailsNavigationData = {
                "oprAccountList": list
            };
            window.oe_navigate_to(detailsURL, detailsNavigationData);
        });
    }

    _navigateToCard() {
        if (this.validateElement(this.cardsMenuId)) {
      this.fire("oe-show-message", getLabel('l_PermissionErrorMessage'));
            return;
        }
        if (this.cards.length == 0)
             // commented below line as this function not defined
            // this._applyCreditCard();
            return;
        else if (this.cards.length >= 1) {
           this.fire("start-processing-loader");
           setTimeout(function() {
              this.fire("stop-processing-loader");
            }.bind(this), 1500);
            let detailsURL = "/credit-card-dashboard";
            let detailsNavigationData = {};
            if (!window.google || !window.google.charts) {
                var script = document.createElement('script');
                script.type = "application/javascript";
                script.async = false;
                script.src = 'https://www.gstatic.com/charts/loader.js';
                script.onload = function() {
                    window.oe_navigate_to(detailsURL, detailsNavigationData);
                }
                script.onerror = function() {
                    window.oe_navigate_to(detailsURL, detailsNavigationData);
                }
                document.head.appendChild(script);
            } else {
                window.oe_navigate_to(detailsURL, detailsNavigationData);
            }
        } else {
            let detailsURL = "/credit-card-detail";
            let detailsNavigationData = {
                creditCardNumber: this.cards[0].accountId
            };
            if (!window.google || !window.google.charts) {
                var script1 = document.createElement('script');
                script1.type = "application/javascript";
                script1.async = false;
                script1.src = 'https://www.gstatic.com/charts/loader.js';
                script1.onload = function() {
                    window.oe_navigate_to(detailsURL, detailsNavigationData);
                }
                script1.onerror = function() {
                    window.oe_navigate_to(detailsURL, detailsNavigationData);
                }
                document.head.appendChild(script1);
            } else {
                window.oe_navigate_to(detailsURL, detailsNavigationData);
            }
        }
    }

    _showNextChart() {
        if (this.portfolioData.chartNavHeading === this.labelHeadingLists.assets) {
            this._setLiabilitiesValues();
        } else {
            this._setAssetsValues();
        }
    }

    _showPrevChart() {
        if (this.portfolioData.chartNavHeading === this.labelHeadingLists.liabilities) {
            this._setAssetsValues();
        } else if (this.portfolioData.chartNavHeading === this.labelHeadingLists.assets) {
            this.getTotalValues();
        }
    }

    _getChartDetails(e) {
        var activePoint = this.myChart.getElementAtEvent(e)[0];
        if (activePoint) {
            let selectedLabel = activePoint._chart.data.labels[activePoint._index]
            this._getRowDetails(selectedLabel);
        } else if (!activePoint && this.portfolioData.chartNavHeading !== this.chartLabels.assetsAndLiabilities) {
            this.getTotalValues();
            this.portfolioData.chartNavHeading = this.chartLabels.assetsAndLiabilities;
            this.showLeftChevron = false;
            this.showRightChevron = true;
        }
    }

    drawGraph() {
        let canvas = this.$.myChart.querySelector('#myPortfolio');
        let chartDataValues = [];
        let chartDataObject = {};
        this.chartData = [];
        if (!canvas) {
            canvas = document.createElement("canvas");
            canvas.id = "myPortfolio";
            canvas.height = "300";
            canvas.width = "300";
            let self = this;
            canvas.addEventListener('click', function(event) {
                self._getChartDetails(event);
            })
            this.$.myChart.appendChild(canvas);
            this.getTotalValues();
            chartDataObject = this.portfolioData;
            chartDataValues = this.portfolioData.assetsAndLiabilities;
        }
        if (this.portfolioData && this.portfolioData.assetsAndLiabilities) {
            chartDataObject = this.portfolioData;
            chartDataValues = chartDataObject.assetsAndLiabilities;
        } else if (this.portfolioData) {
            canvas = this.$.myChart.querySelector('#myPortfolio');
            chartDataObject = this.portfolioData;
            chartDataValues = this.portfolioData.individualChartValues;
			if (this.portfolioData.labels[0] == "l_operativeAccounts") {
          if (this.savingsCurrency.length == 0 || !this.savingsCurrency.hasOwnProperty(this.selectedCurrency)) {
              this.savingsAvailable = false;
          } else {
              this.savingsAvailable = true;
                }
              }
            if (this.portfolioData.labels[1] == "l_investments" && chartDataValues[1] === 0) {
                if (this.investmentCurrency.length == 0 || !this.investmentCurrency.hasOwnProperty(this.selectedCurrency)) {
                    this.investmentsAvailable = false;
                } else {
                  this.investmentsAvailable = true;
                }
            }
        }
        if (chartDataValues[0] === 0 && chartDataValues[1] === 0) {
            chartDataValues[0] = 1;
            this.displayChartNoData = true;
            this.chartBackgroundColor[0] = '#cccccc';
        } else {
            this.displayChartNoData = false;
        }
        this.showLoader = false;
        this.chartData = chartDataObject.chartLabelObject;
        let ctx = canvas.getContext("2d");
        const self = this;
        this.myChart = new Chart(ctx, {
            type: "doughnut",
            data: {
                datasets: [{
                    data: chartDataValues,
                    backgroundColor: this.chartBackgroundColor,
                    hoverBackgroundColor: this.hoverColor
                }],
                borderWidth: 0,
                labels: chartDataObject.labels,
            },
            options: {
                //cutoutPercentage: 40,
                responsive: false,
                cutoutPercentage: 60,
                aspectRatio: 1,
                legend: {
                    display: false
                },
                tooltips: {
                    enabled: true,
                    bodyFontSize: 17,
                    callbacks: {
                        label: function(tooltipItem, data) {
                            if (self.displayChartNoData) {
                                return ` ${getLabel('m_noData')}`;
                            }
                            const index = tooltipItem.index;
                            const currencyValue = currency.symbolize(`${self.selectedCurrency} ${data.datasets[0].data[index]}`);
                            const label = getLabel(data.labels[index]);
                            return ` ${label}: ${currencyValue}`
                        }
                    }
                }
            },
        });
    }

    _currencySelectorChanged(e) {
        sessionStorage.setItem('SelectedCurrency', e);
        if (e !== '' && this.selectedCurrency) {

            this.selectedCurrency = e;
            this.getTotalValues()
        }
    }

    createLoanAccountDIB() {
        var isExistingCustomer = "Y";
        var existingCustomerInfo = {};
        var self = this;
        existingCustomerInfo.isExistingCustomer = isExistingCustomer;
        //existingCustomerInfo.selectedProductCategories = ["PersonalLoan", "HomeLoan"];
        // Replacing the hardcoded values by fetching it from API call as part of feature 301794
        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = "/api/retailproduct-categories?filter[where][mainCategory]=1";
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function(event) {
            let response = event.detail.response;
            existingCustomerInfo.selectedProductCategories = _.map(response.productCategoryDetails, function(prod) { return prod.productCategoryId.codeDescription });
            window.oe_navigate_to("/directbanking", {
                "existingCustomerInfo": existingCustomerInfo
            });
        });
        ajaxCall.addEventListener("error", function(e) {
            existingCustomerInfo.selectedProductCategories = [];
            var errMsg = JSON.parse(e.detail.request.__data.response.error.message["channelcontext"]);
            self.fire('oe-show-error', errMsg.status.message[0].messageDesc);
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
    }

    createInvestmentAccountDIB() {
        var isExistingCustomer = "Y";
        var existingCustomerInfo = {};
        var self = this;
        existingCustomerInfo.isExistingCustomer = isExistingCustomer;
        //existingCustomerInfo.selectedProductCategories = ["TermDeposit"];
        // Replacing the hardcoded values by fetching it from API call as part of feature 301794
        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = "/api/retailproduct-categories?filter[where][mainCategory]=7";
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function(event) {
            let response = event.detail.response;
            existingCustomerInfo.selectedProductCategories = _.map(response.productCategoryDetails, function(prod) { return prod.productCategoryId.codeDescription });
            window.oe_navigate_to("/directbanking", {
                "existingCustomerInfo": existingCustomerInfo
            });
        });
        ajaxCall.addEventListener("error", function(e) {
            existingCustomerInfo.selectedProductCategories = [];
            var errMsg = JSON.parse(e.detail.request.__data.response.error.message["channelcontext"]);
            self.fire('oe-show-error', errMsg.status.message[0].messageDesc);
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
    }

    createCardsAccountDIB() {
        var isExistingCustomer = "Y";
        var existingCustomerInfo = {};
        var self = this;
        existingCustomerInfo.isExistingCustomer = isExistingCustomer;
        //existingCustomerInfo.selectedProductCategories = ["CreditCard"];
        // Replacing the hardcoded values by fetching it from API call as part of feature 301794
        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = "/api/retailproduct-categories?filter[where][mainCategory]=33";
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function(event) {
            let response = event.detail.response;
            existingCustomerInfo.selectedProductCategories = _.map(response.productCategoryDetails, function(prod) { return prod.productCategoryId.codeDescription });
            window.oe_navigate_to("/directbanking", {
                "existingCustomerInfo": existingCustomerInfo
            });
        });
        ajaxCall.addEventListener("error", function(e) {
            existingCustomerInfo.selectedProductCategories = [];
            var errMsg = JSON.parse(e.detail.request.__data.response.error.message["channelcontext"]);
            self.fire('oe-show-error', errMsg.status.message[0].messageDesc);
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
    }

    createSavingsAccountDIB() {
        var isExistingCustomer = "Y";
        var existingCustomerInfo = {};
        var self = this;
        existingCustomerInfo.isExistingCustomer = isExistingCustomer;
        //existingCustomerInfo.selectedProductCategories = ["Savings", "Current"];
        // Replacing the hardcoded values by fetching it from API call as part of feature 301794
        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = "/api/retailproduct-categories?filter[where][mainCategory]=5|6";
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function(event) {
            let response = event.detail.response;
            existingCustomerInfo.selectedProductCategories = _.map(response.productCategoryDetails, function(prod) { return prod.productCategoryId.codeDescription });
            window.oe_navigate_to("/directbanking", {
                "existingCustomerInfo": existingCustomerInfo
            });
        });
        ajaxCall.addEventListener("error", function(e) {
            existingCustomerInfo.selectedProductCategories = [];
            var errMsg = JSON.parse(e.detail.request.__data.response.error.message["channelcontext"]);
            self.fire('oe-show-error', errMsg.status.message[0].messageDesc);
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
    }
}

// Register the element with the browser
customElements.define("dashboard-portfolio", dashboardPortfolio);